<template>
    <header :class="['header', theme]" :data-search-state="searchState" :style="cssVars">
        <mq-layout :mq="['mobile_sm', 'mobile_md']" class="header__mq-layout -wrap">
            <Logo />
            <div class="header__mobile">
                <SearchMobile v-model="searchPhrase" v-on:clearSearch="onClearSearch" />
            </div>
        </mq-layout>

        <mq-layout mq="desktop_l+" class="header__mq-layout -wrap">
            <Logo />
            <SubjectAreasMenu />
            <Search />
            <HelpCenter />
            <SelectLanguage />
            <LoginProfileMenu />
        </mq-layout>
    </header>
</template>

<script>
    import LoginProfileMenu from 'components/layout/loginprofilemenu/LoginProfileMenu'
    import Logo from 'components/layout/Logo'
    import SearchMobile from 'components/layout/SearchMobile'
    import SelectLanguage from 'components/layout/SelectLanguage'
    import { mapGetters } from 'vuex'
    import Search from 'components/layout/Search'
    import SubjectAreasMenu from 'components/layout/SubjectAreasMenu'
    import searchHelper from 'components/layout/mixins/searchHelper'
    import HelpCenter from 'components/layout/HelpCenter'

    export default {
        components: {
            LoginProfileMenu,
            Logo,
            SearchMobile,
            SelectLanguage,
            Search,
            SubjectAreasMenu,
            HelpCenter
        },
        mixins: [searchHelper],
        inject: ['headerTheme'],
        data () {
            return {
                showTip: false,
                search: ''
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                isSearchMobileCollapsed: 'getIsSearchMobileCollapsed',
                getNotificationHeight: 'getNotificationHeight'
            }),
            theme () {
                return this.headerTheme()
            },
            searchState () {
                return this.isSearchMobileCollapsed ? 'close' : 'open'
            },
            cssVars () {
                if (this.isMobileView) {
                    return { '--top': 0 }
                }
                return { '--top': this.getNotificationHeight + 'px'}
            }
        },
        methods: {
            logout () {
                this.$store.dispatch('logout')
                this.$router.push({ name: 'home' }).catch(err => {})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        right: 0;
        background-color: $white;
        display: flex;
        align-items: center;
        transition: 0.15s all ease-out;
        left: 0;
        height: 64px;
        position: fixed;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
        top: var(--top);

        [class*="desktop"] & {
            height: 80px;
            z-index: 10000;

            &.dark {
                background-color: transparent;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                position: absolute;
            }

            &.light {
                position: fixed;
                background-color: $white;
            }
        }

        [class*="mobile"] & {
            z-index: 1000;
        }

        &[data-search-state="open"] {
            z-index: 1000
        }

        &__mq-layout {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;

            [class*="mobile"] & {
                background-color: $white;
            }

            [class*="desktop"] & {
                gap: 15px;
            }

            [class*="desktop_xxxl"] & {
                gap: 35px;
            }
        }

        &__mobile {
            display: flex;
            align-items: center;

            .icon-search {
                font-size: 3rem;
                margin: 0 0 0 20px;
            }
        }
    }
</style>
